/**
 *
 */
export const chevronUp = {
    paths: [
        {
            d: 'M3.22 10.53a.749.749 0 0 1 0-1.06l4.25-4.25a.749.749 0 0 1 1.06 0l4.25 4.25a.749.749 0 1 1-1.06 1.06L8 6.811 4.28 10.53a.749.749 0 0 1-1.06 0Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=chevron-up.js.map